let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("x6CsX")).then(() => parcelRequire('jeFtr'));